import(/* webpackMode: "eager" */ "/app/src/components/common/ROISimulator.tsx")